<template>
  <BaseTemplate>
    <div class="user-register">
      <Title jpn="Address Registration" />
      <div class="message">
        Please register your shipping information for product shipment.
      </div>
      <div class="input-area">
        <!-- 国設定は日本固定のため非表示
        <div class="address_area">
          <LabelInput
            class="label-input"
            labelText="Country"
            annotation=""
          >
            <SelectBox
              :options="countryList"
              :selectedOption="countryId"
              @handleSelectChange="changeCountry"
            />
            <ErrorMessage
              v-if="errorMessageCountryId"
              class="error-message"
              :message="errorMessageCountryId"
            />
          </LabelInput>
        </div>
        -->
          <LabelInput
            class="label-input"
            labelText="Zip code"
            annotation=""
          >
            <div class="announce-area">
              <TextBox
                class="text-box zip-code"
                inputType="Number"
                :value="zipCode"
                placeholder=""
                @handleTextInput="inputZipCode"
                @handleTextChange="changeZipCode"
              />
            </div>
            <ErrorMessage
              v-if="errorMessageZipCode"
              class="error-message"
              :message="errorMessageZipCode"
            />
          </LabelInput>
          <LabelInput class="label-input" labelText="Prefecture">
            <TextBox
              class="text-box shiku"
              inputType="text"
              :value="country"
              placeholder=""
              @handleTextInput="inputCountry"
            />
            <ErrorMessage
              v-if="errorMessageCountry"
              class="error-message"
              :message="errorMessageCountry"
            />
          </LabelInput>
          <LabelInput class="label-input" labelText="City">
            <TextBox
              class="text-box shiku"
              inputType="text"
              :value="shiku"
              placeholder=""
              @handleTextInput="inputShiku"
            />
            <ErrorMessage
              v-if="errorMessageShiku"
              class="error-message"
              :message="errorMessageShiku"
            />
          </LabelInput>
          <LabelInput class="label-input" labelText="Address1">
            <TextBox
              class="text-box address"
              inputType="text"
              :value="address"
              placeholder=""
              @handleTextInput="inputAddress"
            />
            <ErrorMessage
              v-if="errorMessageAddress"
              class="error-message"
              :message="errorMessageAddress"
            />
          </LabelInput>
          <LabelInput
            class="label-input"
            labelText="Address2"
          >
            <TextBox
              class="text-box address"
              inputType="text"
              :value="building"
              placeholder=""
              @handleTextInput="inputBuilding"
            />
            <ErrorMessage
              v-if="errorMessageBuilding"
              class="error-message"
              :message="errorMessageBuilding"
            />
          </LabelInput>
        </div>

        <SubTitle>Tel</SubTitle>
        <div class="address_area">
          <TextBox
            class="text-box tel"
            inputType="Number"
            :value="tel"
            placeholder=""
            @handleTextInput="inputTel"
          />
          <ErrorMessage
            v-if="errorMessageTel"
            class="error-message"
            :message="errorMessageTel"
          />
        </div>

        <SubTitle>Referral Code</SubTitle>
        <div class="address_area">
          <TextBox
            class="text-box mail"
            inputType="text"
            :value="referralCode"
            placeholder=""
            @handleTextInput="inputReferralCode"
          />
          <ErrorMessage
            v-if="errorMessageReferralCode"
            class="error-message"
            :message="errorMessageReferralCode"
          />
        </div>

        <div class="address_area">
          <div class="agree_area">
            <label @click="changeAgreeCheckbox">
              <CheckBox :isChecked="agreeCheck" />
              <div class="agree_label">Agree to the terms of use and register as a member</div>
            </label>
          </div>
        </div>

        <BlackGradationButton
          v-if="agreeCheck"
          class="square-button"
          text="Check input info"
          @handleSquareBtnClick="goToConfirmUserRegister"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import CheckBox from '@/components/atoms/CheckBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import Title from '@/components/molecules/Title.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';
import SelectBox from '@/components/atoms/SelectBox.vue';

export default {
  name: 'UserRegister',
  mixins: [t],

  components: {
    BaseTemplate,
    TextBox,
    CheckBox,
    ErrorMessage,
    LabelInput,
    Title,
    SubTitle,
    BlackGradationButton,
    SelectBox,
  },

  data: () => ({
    tel: null,
    zipCode: null,
    prefectureId: null,
    country: null,
    shiku: null,
    agreeCheck: false,
    address: null,
    building: null,
    referralCode: null,
    countryId: null,
    errorMessageTel: null,
    errorMessageZipCode: null,
    errorMessagePrefectureId: null,
    errorMessageShiku: null,
    errorMessageAddress: null,
    errorMessageBuilding: null,
    errorMessageReferralCode: null,
    errorMessageCountry: null,
    errorMessageCountryId: null,
  }),

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      currentAddress: 'zipCode/currentAddress',
      countryList: 'country/countryList',
      changeUserAddressResult: 'user/changeUserAddressResult',
      countryCheckResult: 'country/countryCheckResult',
    }),
  },

  watch: {
    changeUserAddressResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.$router.push('/');
        } else {
          const {
            lastName, firstName, middleName, tel, mail, zipcode,
            pref_id: prefId, shiku, address, building, country_id: countryId,
          } = newVal.errors;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageMail = mail ? mail[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
        }
      }
    },
    countryCheckResult() {
      if (this.countryCheckResult) {
        if (this.countryCheckResult.is_login && this.countryCheckResult.is_country) {
          this.$router.push({ path: '/' });
        }
      }
    },
  },

  created() {
    this.tel = this.$route.query.tel || null;
    this.zipCode = this.$route.query.zipCode || null;
    this.prefectureId = this.$route.query.prefectureId || null;
    this.country = this.$route.query.country || null;
    this.shiku = this.$route.query.shiku || null;
    this.address = this.$route.query.address || null;
    this.building = this.$route.query.building || null;
    this.referralCode = this.$route.query.referralCode || null;
    this.countryId = this.$route.query.countryId || null;
    this.$store.dispatch('prefecture/setPrefectureList');
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('country/setCountryCheckResult');
  },

  methods: {
    inputTel(tel) {
      this.tel = tel;
    },
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    inputCountry(country) {
      this.country = country;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    inputReferralCode(referralCode) {
      this.referralCode = referralCode;
    },
    changeAgreeCheckbox() {
      this.agreeCheck = !this.agreeCheck;
    },
    changeCountry(country) {
      this.countryId = country;
    },
    goToConfirmUserRegister() {
      this.prefectureId = 99;
      const postParams = {
        tel: this.tel,
        zipcode: this.zipCode,
        country: this.country,
        pref_id: this.prefectureId,
        shiku: this.shiku,
        address: this.address,
        building: this.building,
        referralCode: this.referralCode,
        country_id: '84', // 日本固定
      };
      this.$store.dispatch('user/changeUserAddress', { postParams });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-register{
  width: 100%;
  max-width: 600px;
  min-height: 100%;
  padding: 50px 30px;
  margin: 0px auto;
  @include appendMap($backgroundStyleMap);
  .description{
    display: inline-block;
    color: $black;
    height: 20px;
    margin-top: 30px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 23.4px;
    text-align: center;
  }
  .input-area {
    margin-top: 20px;
    .user-name{
      display: flex;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
      .last-name-container{
        flex: 1 1 150px;
        min-width: 0;
      }
      .first-name-container{
        flex: 1 1 150px;
        min-width: 0;
        margin-left: 15px;
      }
      .text-box{
        margin-top: 0px;
      }
    }
  }
  .over {
    margin-top: 10px;
    color: $white!important;
  }
  .announce-area {
    display: flex;
    align-items: center;
    .announce {
      color: $black;
      margin-left: 10px;
      font-size: 14px;
      width: 300px;
    }
  }
  .address_area {
    margin: 10px 0;
    .row {
      margin: 5px 0;
    }
  }
  .label-input{
    width: 100%;
    margin-top: 10px;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    .text-box{
      width: 100%;
      height: 40px;
    }
    .select-box{
      margin-top: 10px;
      width: 100%;
      height: 40px;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
}
.flex_box {
  display: flex;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
  .label-input {
    &:nth-child(1) {
      margin-right: 5px;
    }
    &:nth-child(2) {
      margin-left: 5px;
      margin-right: 5px;
    }
    &:nth-child(3) {
      margin-left: 5px;
    }
  }
}
.agree_area {
  margin-top: 20px;
  label {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    .agree_label {
      margin-left: 10px;
    }
  }
}
.message {
  color: #fff;
  text-align: center;
}
@media screen and  (max-width: $tabletWidth) {
  .user-register{
    padding: 30px 0 20px;
    .description{
      margin-top: 10px;
      padding-left: 20px;
      text-align: left;
    }
    .over {
      padding: 0 10px;
      font-size: 90%;
    }
    .input-area {
      padding: 0 10px;
    }
  }
}
</style>
